import { render } from "./Product_bkp.vue?vue&type=template&id=7a2ab136&scoped=true"
import script from "./Product_bkp.vue?vue&type=script&lang=js"
export * from "./Product_bkp.vue?vue&type=script&lang=js"

import "./custom-product_bkp.scss?vue&type=style&index=0&id=7a2ab136&lang=scss&scoped=true"
import "./Product_bkp.vue?vue&type=style&index=1&id=7a2ab136&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a2ab136"]])

export default __exports__